import { IAvatarModelOption } from 'types/avatar'
import { estimateAvatarSeconds } from 'utils/avatar'
import { TGenerateVariant } from './consts'

export const resolveVariant = (
  isFreeUser: boolean,
  hasUsedFreeTrial: boolean,
  hasCredits: boolean
): TGenerateVariant => {
  if (!isFreeUser) return 'credits'
  // Gift still available — use it first (it's free, don't burn credits).
  if (!hasUsedFreeTrial) return 'free-trial'
  // Gift used: a free user can still generate by spending credits; only route to
  // the upgrade button when they have none.
  return hasCredits ? 'credits' : 'premium'
}

// Estimate the credits an avatar generation will cost: the speech text length
// maps to seconds (12 chars ≈ 1s), and each second costs `credit` for the
// currently selected quality (read from the duration=1 model option).
export const calcAvatarCost = (
  text: string,
  quality: number,
  oneSecondOption?: IAvatarModelOption
): number => {
  const qualityOption = oneSecondOption?.qualities.find(
    q => q.quality === quality
  )
  const seconds = estimateAvatarSeconds(text)
  if (!qualityOption || !seconds) return 0
  return Math.ceil(qualityOption.credit * seconds)
}
